// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3bw-4","title":"Images45_title__3HzFc","images":"Images45_images__3EJUq"};